export const GET_DEFAULT_COURSE_REQUEST = 'GET_DEFAULT_COURSE_REQUEST';
export const GET_DEFAULT_COURSE_SUCCESS = 'GET_DEFAULT_COURSE_SUCCESS';
export const GET_DEFAULT_COURSE_FAILURE = 'GET_DEFAULT_COURSE_FAILURE';

export const getDefaultCourses = () =>
    ({ type: GET_DEFAULT_COURSE_REQUEST });

export const getDefaultCoursesSuccess = data =>
    ({ type: GET_DEFAULT_COURSE_SUCCESS, data });

export const getDefaultCoursesFailure = () =>
    ({ type: GET_DEFAULT_COURSE_FAILURE });

export const SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';

export const showCourseDetails = courseId =>
    ({ type: SHOW_COURSE_DETAILS, courseId });

export const HIDE_COURSE_DETAILS = 'HIDE_COURSE_DETAILS';

export const hideCourseDetails = () =>
    ({ type: HIDE_COURSE_DETAILS });

export const FETCH_COURSE_DETAILS_REQUEST = 'FETCH_COURSE_DETAILS_REQUEST';
export const FETCH_COURSE_DETAILS_SUCCESS = 'FETCH_COURSE_DETAILS_SUCCESS';
export const FETCH_COURSE_DETAILS_FAILURE = 'FETCH_COURSE_DETAILS_FAILURE';

export const fetchCourseDetails = () =>
    ({ type: FETCH_COURSE_DETAILS_REQUEST });

export const fetchCourseDetailsSuccess = data =>
    ({ type: FETCH_COURSE_DETAILS_SUCCESS, courseDetails: data });

export const fetchCourseDetailsFailure = () =>
    ({ type: FETCH_COURSE_DETAILS_FAILURE });
export const SAVE_DEFAULT_COURSE_REQUEST = 'SAVE_DEFAULT_COURSE_REQUEST';
export const SAVE_DEFAULT_COURSE_SUCCESS = 'SAVE_DEFAULT_COURSE_SUCCESS';
export const SAVE_DEFAULT_COURSE_FAILURE = 'SAVE_DEFAULT_COURSE_FAILURE';

export const saveDefaultCourses = yearGroupCourses =>
    ({ type: SAVE_DEFAULT_COURSE_REQUEST, yearGroupCourses });

export const saveDefaultCoursesSuccess = savingDefaultCourses =>
    ({ type: SAVE_DEFAULT_COURSE_SUCCESS, savingDefaultCourses });

export const saveDefaultCoursesFailure = savingDefaultCourses =>
    ({ type: SAVE_DEFAULT_COURSE_FAILURE, savingDefaultCourses });



// WEBPACK FOOTER //
// ./app/containers/manage-default-courses/actions.js